import { Box, Button, Stack, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  isSubmitting: boolean;
  onUnpublish?: () => void;
  onArchive?: () => void;
};

export const LiveCampaignActions = ({
  isSubmitting,
  onUnpublish,
  onArchive,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1} alignItems="center">
      <Typography variant="h6" color="text.primary">
        {t(RESOURCES.CampaignIsLive)}
      </Typography>
      <Box display="flex" gap={2}>
        {onUnpublish && (
          <Button
            size="small"
            endIcon={<EditIcon />}
            onClick={onUnpublish}
            disabled={isSubmitting}
            sx={{ "& .MuiButton-endIcon": { ml: 0.5 } }}
          >
            {t(RESOURCES.UnpublishButton)}
          </Button>
        )}
        {onArchive && (
          <Button
            size="small"
            color="error"
            endIcon={<DeleteIcon />}
            onClick={onArchive}
            disabled={isSubmitting}
            sx={{ "& .MuiButton-endIcon": { ml: 0.5 } }}
          >
            {t(RESOURCES.ArchiveButton)}
          </Button>
        )}
      </Box>
    </Stack>
  );
};
